/**
 * @file    theme
 * @scope   SHARED
 * @summary Registers the `solarized` react-data-table theme used by striped legacy tables.
 * @sideEffects Global theme registration on import.
 */
import { createTheme } from 'react-data-table-component';

export const STRIPED_THEME = 'solarized';

createTheme(STRIPED_THEME, {
  divider: { default: '#d9d9d9' },
  striped: { default: '#f1f1f1', text: '#333333' },
});
